var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.7897V4.9997C4.69 4.9997 2 7.6897 2 10.9997C2 11.7897 2.15 12.5597 2.44 13.2497C2.59 13.6097 2.48 14.0197 2.21 14.2897C1.7 14.7997 0.84 14.6197 0.57 13.9497C0.2 13.0397 0 12.0397 0 10.9997C0 6.5797 3.58 2.9997 8 2.9997V1.2097C8 0.759697 8.54 0.539697 8.85 0.849697L11.64 3.6397C11.84 3.8397 11.84 4.1497 11.64 4.3497L8.85 7.1397C8.54 7.4597 8 7.2397 8 6.7897ZM13.56 8.7497C13.41 8.3997 13.52 7.9797 13.79 7.7097C14.3 7.1997 15.16 7.3797 15.43 8.0497C15.8 8.9597 16 9.9597 16 10.9997C16 15.4197 12.42 18.9997 8 18.9997V20.7997C8 21.2397 7.46 21.4597 7.15 21.1497L4.36 18.3597C4.16 18.1597 4.16 17.8497 4.36 17.6497L7.15 14.8597C7.46 14.5397 8 14.7597 8 15.2097V16.9997C11.31 16.9997 14 14.3097 14 10.9997C14 10.2097 13.84 9.4497 13.56 8.7497Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reloadIcon.5d447e63fa9432d7424bbd942fa41a06.svg";
export { ForwardRef as ReactComponent };